import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../constants/animations';
import './Book.css';

const CAL_LINK = 'versa-tch3p8/free-online-visibility-scan-review';

function Book() {
  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Bootstrap the Cal command queue (must happen before script loads)
    const w = window;
    if (!w.Cal) {
      const cal = function () {
        cal.q.push(arguments);
      };
      cal.ns = {};
      cal.q = [];
      w.Cal = cal;
    }

    // Load Cal.com embed script if not already present
    if (!document.querySelector('script[src="https://app.cal.com/embed/embed.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://app.cal.com/embed/embed.js';
      script.async = true;
      document.head.appendChild(script);
    }

    // Queue embed commands — Cal processes these once the script is ready
    w.Cal('init', { origin: 'https://app.cal.com' });
    w.Cal('inline', {
      calLink: CAL_LINK,
      elementOrSelector: '#cal-embed',
      config: { layout: 'month_view' }
    });
    w.Cal('ui', {
      styles: { branding: { brandColor: '#d4af37' } },
      hideEventTypeDetails: false,
      layout: 'month_view'
    });

    // Watch for the iframe to appear so we can hide the spinner
    const observer = new MutationObserver(() => {
      if (containerRef.current && containerRef.current.querySelector('iframe')) {
        setLoaded(true);
        observer.disconnect();
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, { childList: true, subtree: true });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <main className="book-page">
      <div className="book-container">
        <motion.div
          className="book-hero"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
        >
          <motion.h1 variants={fadeInUp} custom={0}>
            Book a Call
          </motion.h1>
          <motion.p variants={fadeInUp} custom={1}>
            Pick a time that works for you. We'll walk through your online
            visibility, answer questions, and map out next steps — no pressure.
          </motion.p>
        </motion.div>

        <motion.div
          className="book-embed-wrapper"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={fadeInUp}
          custom={2}
        >
          {!loaded && (
            <div className="book-loading">
              <div className="book-spinner" />
              <span>Loading calendar…</span>
            </div>
          )}
          <div
            id="cal-embed"
            ref={containerRef}
            className="book-embed"
            style={{ minHeight: loaded ? 'auto' : 0 }}
          />
        </motion.div>
      </div>
    </main>
  );
}

export default Book;
